package net.bothosting.docs.pages.troubleshooting

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initAnother_power_action_is_currently_being_processed_for_this_serverPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("troubleshooting/another_power_action_is_currently_being_processed_for_this_server.md", FrontMatterElement.EmptyMap))
}

@Page("/troubleshooting/another-power-action-is-currently-being-processed-for-this-server")
@Layout(".components.layouts.DocsLayout")
@Composable
fun Another_power_action_is_currently_being_processed_for_this_serverPage() {
    org.jetbrains.compose.web.dom.H1(attrs = { id("another-power-action-is-currently-being-processed-for-this-server") }) {
        org.jetbrains.compose.web.dom.Text("Another power action is currently being processed for this server")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("This error indicates that another power action (start, restart, stop) is currently being processed by the server, and no new actions can be triggered until the current one is finished. Usually this issue is fixed after a few minutes, but it can take longer depending on the node’s load and how heavy the action being processed is. Spamming the buttons will not fix the issue, but will cause it to take longer to resolve itself.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("cannot")
        }
        org.jetbrains.compose.web.dom.Text(" provide an ETA for when the server finishes processing the action or do anything about it. The only thing you can do is wait patiently.")
    }
    com.varabyte.kobweb.silk.components.display.Callout(type = com.varabyte.kobweb.silk.components.display.CalloutType.NOTE, label = null, variant = com.varabyte.kobweb.silk.components.display.CalloutDefaults.Variant) {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text(" Please refrain from opening tickets related to this issue. All you can do is wait patiently, and the support team cannot fix it for you.")
        }
    }
}
